<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-25 13:51:13
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimTransactionPropertyGroup\components\EditMappingPopup5.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-07 14:36:18
-->
<template>
  <normalDialog
    :title="$t('label_essweb_form_property_dialog_title')"
    :dialog="show"
    @close="closeDialog"
    maxWidth="680"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation v-if="PropertyData">
        <v-row align="center">
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_form_property_dialog_propertyNameLabel")
            }}</v-sheet>
            <v-text-field
              single-line
              filled
              dense
              hide-details
              :value="$getCommonLangValue(PropertyData.property_master_name)"
              :disabled="true"
            ></v-text-field>
          </v-col>
          <v-container class="d-flex pa-0">
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              class="text-capitalize"
              color="primary"
              v-if="!view"
              @click="addValue()"
            >
              {{ $t("label_essweb_form_property_dialog_addValueBtnLabel") }}
              <span class="material-icons-round">add</span>
            </v-btn>
          </v-container>
          <template v-for="(item, index) in MappingData">
            <v-row :key="`row${index}`" class="pa-0 ma-0">
              <v-col :md="view ? 6 : 5" class="pt-0 pb-0">
                <DateTimePicker
                  type="date"
                  :filled="!view"
                  :readonly="view"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :defaultTime="item.effective_utc_datetime"
                  :label="
                    $t(
                      'label_essweb_form_property_dialog_effectiveStartDateLabel'
                    )
                  "
                  placeholder="YYYY/MM/DD"
                  :refuseDate="refuseDate"
                  @change="(time) => (item.effective_utc_datetime = time)"
                ></DateTimePicker>
              </v-col>
              <v-col :md="view ? 6 : 5" class="pt-0 pb-0">
                <template v-if="prompt">
                  <v-sheet class="mrc_text_require text--secondary">{{
                    $t("label_essweb_form_property_dialog_valueLabel")
                  }}</v-sheet>
                  <v-autocomplete
                    :items="promptData"
                    item-text="view_fields"
                    item-value="value_field"
                    dense
                    :rules="$GetRules(['_Require_Rules'], [null])"
                    v-model="item.value"
                    :append-icon="!view ? 'arrow_drop_down' : ''"
                    single-line
                    :placeholder="
                      $t('label_essweb_form_property_dialog_valueLabel')
                    "
                    :menu-props="{
                      offsetY: true,
                      transition: 'slide-y-transition',
                      rounded: true,
                      contentClass: 'elevation-4',
                    }"
                    :filled="!view"
                    :readonly="view"
                  >
                    <template v-slot:no-data> <noContent /> </template
                  ></v-autocomplete>
                </template>
                <template v-if="data_type">
                  <v-sheet class="mrc_text_require text--secondary">{{
                    $t("label_essweb_form_property_dialog_valueLabel")
                  }}</v-sheet>
                  <template v-if="data_type === 'boolean'">
                    <v-select
                      :items="[
                        {
                          text: $t('label_essweb_system_label_trueLabel'),
                          value: '1',
                        },
                        {
                          text: $t('label_essweb_system_label_falseLabel'),
                          value: '0',
                        },
                      ]"
                      item-text="text"
                      item-value="value"
                      :append-icon="!view ? 'arrow_drop_down' : ''"
                      :filled="!view"
                      :readonly="view"
                      :menu-props="{
                        offsetY: true,
                        transition: 'slide-y-transition',
                        rounded: true,
                        contentClass: 'elevation-4',
                      }"
                      single-line
                      v-model="item.value"
                      :label="
                        $t('label_essweb_system_label_trueLabel') +
                        '/' +
                        $t('label_essweb_system_label_falseLabel')
                      "
                      dense
                    >
                      <template v-slot:no-data> <noContent /> </template
                    ></v-select>
                  </template>
                  <template
                    v-if="data_type === 'int' || data_type === 'bigint'"
                  >
                    <v-text-field
                      single-line
                      :type="!view ? 'number' : 'text'"
                      :rules="
                        $GetRules(
                          [
                            '_Require_Rules',
                            data_type === 'bigint'
                              ? '_Number_negative_reduce'
                              : '_Number_negative',
                          ],
                          [null, null]
                        )
                      "
                      v-model="item.value"
                      :placeholder="
                        $t('label_essweb_form_property_dialog_valueLabel')
                      "
                      :filled="!view"
                      :readonly="view"
                      dense
                    ></v-text-field>
                  </template>
                  <template v-if="data_type === 'String'">
                    <v-text-field
                      single-line
                      type="string"
                      :rules="$GetRules(['_Require_Rules'], [null])"
                      v-model="item.value"
                      :placeholder="
                        $t('label_essweb_form_property_dialog_valueLabel')
                      "
                      :filled="!view"
                      :readonly="view"
                      dense
                    ></v-text-field>
                  </template>
                </template>
              </v-col>
              <v-col :md="view ? 0 : 1" class="d-flex align-center pt-0 pb-0">
                <v-btn icon @click="onDelete(item.actionid)" v-if="!view">
                  <span class="material-icons-round">delete</span>
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn @save="toSave" @cancel="closeDialog" v-if="!view" />
    </template>
  </normalDialog>
</template>
<script>
import dayjs from "dayjs";

import { mapGetters } from "vuex";
export default {
  name: "EditMappingPopup",
  computed: {
    ...mapGetters(["defaultUTC"]),
    refuseDate() {
      let arr = [];
      this.MappingData.forEach((item) => {
        if (item.effective_utc_datetime) {
          arr.push(item.effective_utc_datetime);
        }
      });
      return arr;
    },
    promptData() {
      return this.$getSelectTrans(this.promptDataList, "view_fields");
    },
  },
  props: {
    view: { default: false, type: Boolean },
    show: { default: false, type: Boolean },
    PropertyData: { default: "", type: [Object, String] },
    curGroupId: { default: "", type: String },
  },
  data() {
    return {
      MappingData: [],
      promptDataList: [],
      prompt: null,
      curDate: null,
      curData: [],
      deleteArr: [],
      data_type: null,
      insterUuid: 0,
    };
  },
  watch: {
    show(val) {
      const that = this;
      if (!val) {
        this.MappingData = [];
      } else {
        this.curData = this.PropertyData;
      }
    },
    PropertyData(val) {
      this.prompt = null;
      this.data_type = null;
      if (val) {
        if (val.prompt_name) {
          this.prompt = val.prompt_name;
        } else {
          if (val.data_type) {
            this.data_type = val.data_type;
          }
        }
        this.getDetail(val.uuid, val.property_master_code);
      }
    },
    prompt(val) {
      //高级参照获取
      const that = this;
      if (val)
        this.$findPrompt({
          prompt_name: val,
        }).then((res) => {
          that.promptDataList = res.data;
        });
    },
  },
  mounted() {},
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    getDetail: function (id, code) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_transaction_type_property",
        url: "/claim-transaction-type-property/get-details/",
        data: {
          // uuid: id,
          claim_transaction_type_property_group_uuid: this.curGroupId,
          claim_transaction_type_property_master_code: code,
        },
      }).then((res) => {
        res.data.map((item) => {
          that.insterUuid = that.insterUuid + 1;
          item["actionid"] = that.insterUuid;
          if (item["value"] === "true") item["value"] = "1";
          if (item["value"] === "false") item["value"] = "0";
          item.effective_utc_datetime = that.$getDateTime(
            item.effective_utc_datetime,
            "YYYY-MM-DD"
          );
        });
        that.MappingData = res.data;
      });
    },
    toSave: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }

      // this.curData["changeList"] = this.MappingData;
      this.$emit("confirm", this.curData, this.deleteArr, this.MappingData);
    },
    onDelete: function (actionid) {
      const that = this;
      this.MappingData = this.MappingData.filter((ele) => {
        if (ele.actionid === actionid && ele["uuid"]) {
          that.deleteArr.push(ele["uuid"]);
        }
        return ele.actionid !== actionid;
      });
    },
    addValue: function () {
      this.insterUuid = this.insterUuid + 1;
      this.MappingData.push({
        actionid: this.insterUuid,
        claim_transaction_type_property_master_uuid:
          this.PropertyData.claim_transaction_type_property_master_uuid,
        claim_transaction_type_property_master_code:
          this.PropertyData.property_master_code,
        value: "",
        effective_utc_datetime: "",
        effective_time_zone: this.defaultUTC,
        remarks: "",
      });
    },
  },
};
</script>
